export default __webpack_public_path__ + "ba6d310b64a5bee018dc27da238d585e.svg";